// eslint-disable-next-line max-params
export default function myFetch(method = 'GET', endpoint, body = {}, metadata = {}) {
  const headers = {
    'Content-Type': 'application/json',
  };

  if (metadata.transactionId) {
    headers['x-transaction-id'] = metadata.transactionId;
  }

  if (metadata.correlationId) {
    headers['x-correlation-id'] = metadata.correlationId;
  }

  if (metadata.uiVersion) {
    headers['x-ui-version'] = metadata.uiVersion;
  }

  const opts = {
    method: method && method.toUpperCase(),
    headers,
  };

  if (opts.method !== 'GET' && opts.method !== 'HEAD') {
    opts.headers.browserUrl = global.BROWSER ? window.location.href : 'unknown';
    opts.body = JSON.stringify(body);
    opts.credentials = 'include';
  }

  let transactionId;
  let correlationId;
  let contentType;

  return fetch(endpoint, opts)
    .then((response) => {
      if (!response.ok) {
        const error = new Error('Fetch Error');
        error.response = response.json();
        throw error;
      }

      contentType = response.headers.get('Content-Type');
      transactionId = response.headers.get('x-transaction-id');
      correlationId = response.headers.get('x-correlation-id');

      if (contentType && contentType.indexOf('application/json') !== -1) {
        return response.json();
      }

      return response.text();
    })
    .then((responseBody) => ({
      response: responseBody,
      responseHeaders: transactionId,
      transactionId,
      correlationId,
    }));
}
